const e = {
  name: "renderer",
  components: ["transform", "renderer"]
};
export {
  e as rendererRecipe
};
//# sourceMappingURL=recipes.js.map
